const DESIGN_SYSTEM_CHECKBOX_CLASS = /^\.checkbox_(?:checkbox|square)__/;

const getCheckboxClassName = (selector) => {
    if (typeof selector !== 'string' || !DESIGN_SYSTEM_CHECKBOX_CLASS.test(selector)) {
        return null;
    }

    return selector.slice(1);
};

const installDesignSystemSelectorFallback = () => {
    if (typeof Element === 'undefined' || Element.prototype.__ihoSelectorFallbackInstalled) {
        return;
    }

    const nativeClosest = Element.prototype.closest;
    const nativeQuerySelector = Element.prototype.querySelector;

    Element.prototype.closest = function closest(selector) {
        try {
            return nativeClosest.call(this, selector);
        } catch (error) {
            const className = getCheckboxClassName(selector);
            if (error.name !== 'SyntaxError' || !className) throw error;

            let element = this;
            while (element) {
                if (element.classList.contains(className)) return element;
                element = element.parentElement;
            }

            return null;
        }
    };

    Element.prototype.querySelector = function querySelector(selector) {
        try {
            return nativeQuerySelector.call(this, selector);
        } catch (error) {
            const className = getCheckboxClassName(selector);
            if (error.name !== 'SyntaxError' || !className) throw error;

            return this.getElementsByClassName(className)[0] || null;
        }
    };

    Object.defineProperty(Element.prototype, '__ihoSelectorFallbackInstalled', {
        value: true,
        configurable: false,
        enumerable: false,
        writable: false,
    });
};

export default installDesignSystemSelectorFallback;
